import ModelFactory from 'business/models/ModelFactory';
import { FileResponse, UsageStatClient, UsageStatDTO } from 'business/models/Models';
import BaseService from './BaseService';

export default class UsageStatService extends BaseService {
  async createUserStatService(usageStatDTO: UsageStatDTO) {
    const usageStat: UsageStatClient = ModelFactory(UsageStatClient);
    const us: UsageStatDTO = await usageStat.createUsageStat(usageStatDTO);
    return us;
  }

  async usageStatLogger(feature: string): Promise<any> {
    if (feature.length) {
      const usageStat: UsageStatClient = ModelFactory(UsageStatClient);
      const usageStatDTO = new UsageStatDTO();
      usageStatDTO.feature = feature.trim().replace(/\s/g, '');
      await usageStat.createUsageStat(usageStatDTO);
    }
  }

  async exportUsageStatCSV(timeSpan: number) {
    const usageStat: UsageStatClient = ModelFactory(UsageStatClient, false, true);
    const root: FileResponse = await usageStat.usageStatExportAsCSV(timeSpan);
    return root;
  }
}
